export default {
  title: 'Patient Details',
  subjectId: 'Subject ID',
  patientId: 'Patient ID',
  assignedDevice: 'Assigned Device',
};
